// extracted by mini-css-extract-plugin
export default {"icon_container":"IconRounded_icon_container__r9tRX","icon":"IconRounded_icon__LX+qY"};